import './App.css';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import SathyaSaiMenu from './components/navbarmenu/navmenu';
import YoutubeEmbed from './components/YoutubeEmbed/YoutubeEmbed';
import Announcement from './components/announcement/announcement';
// import EventNote from './components/eventnote/eventnote';
import SSCMKESchedule from './components/eventschedule/eventschedule';
import BottomBanner from './components/bottombanner/bottombanner';
// import Marquee from "react-fast-marquee";


function App() {
  return (
    <div className="App">
      <SathyaSaiMenu />
      {/* <Marquee>
        Sai Ram !!! No Sai Center on Nov 23, 2025 and Nov 30, 2025. We meet next on Dec 7, 2025. See Event Schedule below. 
      </Marquee> */}
      {/* <EventNote title="Sri Sathya Sai BirthDay Celebration" buttonText="Know More" urlref="/sathya100birthday" /> */}
      <Header />
      <SSCMKESchedule />
      <Announcement
        title="Sathya Sai Center Milwaukee Announcement"
      />
      <YoutubeEmbed embedId="https://www.youtube.com/embed/a3OAqdhjWEA?si=5xDsnCKwYEksCOIn"/>
      <BottomBanner />
      <Footer />
    </div>
  );
}

export default App;
